// Package Imports
import React from 'react';
import { Form, Select } from 'antd';

// Project Imports
import { DropdownInputProps } from 'components/dropdown/type';

const DropdownInput = ({
  label,
  name,
  required,
  optionList,
  message,
  style,
  values,
  disabled,
  onChange,
  placeholder,
  onSearch,
  showSearch,
  filterOption,
  optionFilterProp,
  mode,
  size = 'middle',
  className,
  labelClass,
  labelInfo,
}: DropdownInputProps) =>
  name !== undefined ? (
    <div
      className={
        disabled
          ? 'floating-disabled relative custom-dropdown'
          : 'relative custom-dropdown'
      }
    >
      <label className={`floating-label ${labelClass}`}>
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
      {labelInfo ? (
        <div className="mb-1">
          <label className="text-xs truncate flex-1 px-1">{labelInfo}</label>
        </div>
      ) : null}
      <Form.Item
        name={typeof name === 'string' ? [name] : name}
        rules={[{ required, message }]}
        hasFeedback={required || !!values}
        style={style}
      >
        <Select
          onChange={onChange}
          placeholder={placeholder}
          options={optionList}
          showSearch={showSearch || true}
          onSearch={onSearch}
          mode={mode}
          disabled={disabled}
          filterOption={filterOption}
          optionFilterProp={optionFilterProp}
          size={size}
          allowClear={!required}
          // className={size === 'small' ? 'py-sm' : 'py-md'}
        />
      </Form.Item>
    </div>
  ) : (
    <div className="relative custom-dropdown dropdown-arrow-style">
      <label className="floating-label">
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
      <Select
        value={values}
        disabled={disabled}
        style={{ display: 'flex', justifyContent: 'center' }}
        onChange={onChange}
        options={optionList}
        placeholder="Select"
        showSearch={showSearch || true}
        onSearch={onSearch}
        size={size}
        filterOption={filterOption}
        optionFilterProp={optionFilterProp}
        className={className}
        allowClear
        // className={size === 'small' ? 'py-sm' : 'py-md'}
      />
    </div>
  );

export default DropdownInput;
